// "Infra Monitoring" page (2026-08-07) - embeds an AWS CloudWatch shared
// (public, read-only) dashboard via iframe, per AWS's own supported
// embedding feature for CloudWatch dashboard sharing:
// https://docs.aws.amazon.com/AmazonCloudWatch/latest/monitoring/CloudWatch-Dashboard-Sharing.html
//
// This is a genuinely different integration shape from every other page in
// this dashboard - no BFF route, no IAM, no fetch call at all. The shared
// URL itself already carries everything needed to render (region, dashboard
// name, an unauthenticated Cognito identity pool, and a scoped
// CWDBSharing-PublicReadOnlyAccess IAM role, all base64-encoded in the
// `context` query param) - CloudWatch's own JS at that URL handles auth and
// rendering entirely client-side inside the iframe. This app only needs to
// point an <iframe> at it.
//
// One constant, not a per-environment pair - the underlying dashboard
// (decoded `context`: account 474668420215, "Instapay-Prod-Infra-Monitoring")
// is production infrastructure regardless of which environment's build of
// this dashboard (staging or production) is viewing it, so both point at
// the same URL.
export const INFRA_MONITORING_DASHBOARD_URL =
  'https://cloudwatch.amazonaws.com/dashboard.html?dashboard=Instapay-Prod-Infra-Monitoring&context=eyJSIjoidXMtZWFzdC0xIiwiRCI6ImN3LWRiLTQ3NDY2ODQyMDIxNSIsIlUiOiJ1cy1lYXN0LTFfejkzck1HRFM1IiwiQyI6IjVyaHA4MzZzbmo5YnZ1YWg0ZjJ0cGwzOG1uIiwiSSI6InVzLWVhc3QtMTpiOWQzYTc5Ni00NzMxLTQ0MWMtODIyNC0wOTgzNzA2YjczM2YiLCJPIjoiYXJuOmF3czppYW06OjQ3NDY2ODQyMDIxNTpyb2xlL3NlcnZpY2Utcm9sZS9DV0RCU2hhcmluZy1QdWJsaWNSZWFkT25seUFjY2Vzcy1KUUpDTUpSViIsIk0iOiJQdWJsaWMifQ==&start=PT1H&end=null';
